import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Turnstile } from "./constants";
import { useTurnstile } from "./context/TurnstileContext";
import { turnstileEnabled } from "./turnstile-helper";
var secrets = require('../../../../public_keys.json');
// @TODO: remove logs after testing
var TurnstileParentRegistration = function () {
    var _a = useTurnstile(), turnstileData = _a.turnstileData, turnstileEventTracker = _a.turnstileEventTracker;
    var _b = useState(false), hasMounted = _b[0], setHasMounted = _b[1];
    if (!turnstileEnabled()) {
        return null;
    }
    useEffect(function () {
        if (hasMounted)
            return;
        setHasMounted(true);
        turnstileData.current.token = null;
        turnstileData.current.tokenExpired = false;
        turnstileData.current.errorCode = null;
        turnstileData.current.loaded = false;
        turnstileData.current.scriptLoadFailed = false;
        turnstileData.current.timing = {
            scriptLoadStartTime: null,
            scriptLoadEndTime: null,
            scriptLoadDuration: null,
            formSubmitTime: null,
            challengeStartTime: null,
            challengeEndTime: null,
            challengeDuration: null,
            submitToChallengeEndDuration: null,
        };
        var computeLoadDurationStates = function () {
            turnstileData.current.loaded = true;
            turnstileData.current.timing.scriptLoadEndTime = Date.now();
            turnstileData.current.timing.scriptLoadDuration =
                turnstileData.current.timing.scriptLoadStartTime ?
                    (turnstileData.current.timing.scriptLoadEndTime - turnstileData.current.timing.scriptLoadStartTime) / 1000
                    : null;
        };
        var computeChallengeDurationStates = function () {
            turnstileData.current.timing.challengeEndTime = Date.now();
            turnstileData.current.timing.challengeDuration = turnstileData.current.timing.challengeStartTime ? (turnstileData.current.timing.challengeEndTime - turnstileData.current.timing.challengeStartTime) / 1000 : null;
            turnstileData.current.timing.submitToChallengeEndDuration = turnstileData.current.timing.formSubmitTime ? (turnstileData.current.timing.challengeEndTime - turnstileData.current.timing.formSubmitTime) / 1000 : null;
        };
        var resetChallengeDurationStates = function () {
            turnstileData.current.timing.challengeStartTime = Date.now();
            turnstileData.current.timing.challengeEndTime = null;
            turnstileData.current.timing.challengeDuration = null;
            turnstileData.current.timing.submitToChallengeEndDuration = null;
        };
        /**
         * @description This is the callback function for when the turnstile script is loaded successfully.
         */
        window.turnstileOnLoadCallback = function () {
            computeLoadDurationStates();
            if (!window.turnstile) {
                turnstileData.current.scriptLoadFailed = true;
                turnstileEventTracker({
                    event: Turnstile.EVENTS.SCRIPT_NOT_LOADED,
                    props: {
                        validatedUserType: Turnstile.USER_TYPES.PARENT,
                        turnstile_source: Turnstile.EVENT_PROPS.ONLOAD_CALLBACK
                    },
                    trackingOptions: { send_mixpanel: false }
                });
            }
            else {
                turnstileData.current.timing.challengeStartTime = Date.now();
                turnstileData.current.scriptLoadFailed = false;
            }
        };
        /**
         * @description This is the callback function for encountering an error while loading the turnstile script
         */
        window.turnstileOnErrorCallback = function () {
            computeLoadDurationStates();
            turnstileData.current.scriptLoadFailed = true;
            turnstileEventTracker({
                event: Turnstile.EVENTS.SCRIPT_NOT_LOADED,
                props: {
                    validatedUserType: Turnstile.USER_TYPES.PARENT,
                    turnstile_source: Turnstile.EVENT_PROPS.ONERROR_CALLBACK
                },
                trackingOptions: { send_mixpanel: false }
            });
        };
        /**
         * @description This is the callback function for the turnstile success listener
         * @param {string} token - The token from the turnstile widget
         */
        window.turnstileSuccessListener = function (token) {
            computeChallengeDurationStates();
            turnstileData.current.token = token;
            turnstileData.current.errorCode = null;
            turnstileData.current.tokenExpired = false;
            turnstileEventTracker({
                event: Turnstile.EVENTS.VALIDATION_SUCCESS,
                props: {
                    validatedUserType: Turnstile.USER_TYPES.PARENT,
                    turnstile_source: Turnstile.EVENT_PROPS.CHALLENGE_SUCCESS
                },
                trackingOptions: { send_mixpanel: false }
            });
        };
        /**
         * @description This is the callback function for the turnstile error listener
         * @param {string} errorCode - The error code from the turnstile widget
         */
        window.turnstileErrorListener = function (errorCode) {
            computeChallengeDurationStates();
            turnstileData.current.token = null;
            turnstileData.current.errorCode = errorCode;
            turnstileData.current.tokenExpired = false;
            turnstileEventTracker({
                event: Turnstile.EVENTS.VALIDATION_FAILED,
                props: {
                    validatedUserType: Turnstile.USER_TYPES.PARENT,
                    turnstile_source: Turnstile.EVENT_PROPS.CHALLENGE_ERROR,
                    error_code: errorCode
                },
                trackingOptions: { send_mixpanel: false }
            });
        };
        /**
         * @description This is the callback function for the turnstile expiry listener
         */
        window.turnstileExpiryListener = function () {
            resetChallengeDurationStates();
            turnstileData.current.token = null;
            turnstileData.current.tokenExpired = true;
            turnstileData.current.errorCode = null;
        };
        /**
         * @description This is the callback function for the turnstile unsupported callback
         */
        window.turnstileUnsupportedCallback = function () {
            turnstileData.current.errorCode = Turnstile.ERROR_CODES.WIDGET_UNSUPPORTED;
            turnstileEventTracker({
                event: Turnstile.EVENTS.WIDGET_NOT_SUPPORTED,
                props: {
                    validatedUserType: Turnstile.USER_TYPES.PARENT,
                },
                trackingOptions: { send_mixpanel: false }
            });
        };
        // Inject Turnstile script only once
        if (!window.turnstileClientScriptAdded) {
            turnstileData.current.timing.scriptLoadStartTime = Date.now();
            var script = document.createElement("script");
            script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=turnstileOnLoadCallback";
            script.async = true;
            script.addEventListener("error", function () {
                window.turnstileOnErrorCallback();
            });
            document.head.appendChild(script);
            window.turnstileClientScriptAdded = true; // Prevent re-injection
        }
    }, [hasMounted]);
    return (_jsx("div", { className: "cf-turnstile", "data-sitekey": secrets.TURNSTILE_SITE_KEY, "data-action": Turnstile.ACTIONS.PARENT_SIGNUP_FORM, "data-callback": "turnstileSuccessListener", "data-error-callback": "turnstileErrorListener", "data-expired-callback": "turnstileExpiryListener", "data-unsupported-callback": "turnstileUnsupportedCallback", "data-retry": "never", "data-theme": "light", style: { marginTop: '20px', marginBottom: '20px' } }));
};
export default TurnstileParentRegistration;
